module.exports = __webpack_public_path__ + "img/wlbx.5673ae23.png";